export const BASIC_VARIANT_PRICE_DETAILS_SERVER = `
  fragment BasicVariantPriceDetails on Price {
    id
    images
    description
    amountIn(currency: $currency)
    priceIn(currency: $currency)
    displayName
    externalId
  }
`;
